import { IRobaTranslations } from '@/i18n/IRobaTranslations'

const translations: IRobaTranslations = {
  COMMON: {
    CANCEL: 'Annulieren',
    CLEAR_ALL_FILTERS: 'Alle Filter löschen',
    CLEAR_FILTERS: 'Filter löschen',
    COMPANY: 'Firma',
    DATE: 'Datum',
    DATE_CREATED: 'Erstellt am',
    DATE_FROM: 'Datum ab',
    DATE_PLACEHOLDER: 'Tag | Monat | Jahr',
    DATE_UNTIL: 'Datum bis',
    DOCUMENTS: 'Dokumente',
    DOWNLOAD: 'Download',
    EMAIL: 'E-mail',
    FILTERS: 'Filter',
    HELP: 'Hilfe',
    IMPERSONATE: 'Impersonate',
    NAME: 'Name',
    NEXT: 'Nächste',
    NO: 'Nein',
    PREVIOUS: 'Vorherige',
    NO_RESULTS: 'Leider haben wir keine {0} gefunden',
    PASSWORD: 'Passwort',
    REMOVE: 'Entfernen',
    SORT_BY: 'Sortieren auf',
    STATUS_PORTAL_FILTER_TITLE: 'Status portal',
    USER: 'Benutzer',
    VERSIONS: 'Versionen',
    YES: 'Ja',
    PORTAL: 'Portal',
    MY_ENVIRONMENT: 'Meine Umgebung'
  },
  MENU: {
    DASHBOARD: 'Dashboard',
    SHIPMENT_REQUEST: 'Versandanfrage',
    DOCUMENTS: 'Dokumente',
    USER_MANAGEMENT: 'Benutzer des  Dokumentportals',
    COMPANIES: 'Firmen'
  },
  MY_ENVIRONMENT: {
    YOUR_PROFILE: 'Ihr Profil',
    USERS: 'Benutzer',
    NOTIFICATIONS: 'Meldungen',
    SUPPORT: 'Support',
    LOG_OUT: 'Ausloggen',
    CHANGE_COMPANY: 'Firma wechseln',
    CHANGE_USER: 'Benutzer wechseln',
    PROFILE: {
      ROLE: 'Rolle',
      CUSTOMER_NR: 'Kundennummer',
      COMPANY: 'Firma',
      FIRST_NAME: 'Vorname',
      LAST_NAME: 'Nachname',
      STATUS_PORTAL: 'Status',
      PERSONAL_INFORMATION: 'Persönliche Information',
      YOUR_NOTIFICATIONS: 'Ihre Meldungen',
      DOCUMENT_NOTIFICATION: 'Meldung Dokumente',
      GENERAL_NOTIFICATION: 'Allgemeine Meldung',
      GENERAL_NOTIFICATION_TEXT: 'Am Ende jedes Tages erhalten Sie eine allgemeine Meldung um Sie über neue Dokumente auf dem Laufenden zu halten, die dem Portal hinzugefügt wurden.',
      RECEIVE_GENERAL_NOTIFICATION: 'Allgemeine Meldung erhalten',
      NO_SUBSCRIPTIONS: 'Keine angemeldete Meldungen'
    },
    USER: {
      ACTIVE_DESCRIPTION: 'Möchten Sie den Status dieses Benutzers wirklich ändern zu "aktiv"? Bitte beachten Sie, dass alle von diesem Administrator erstellte Benuzter "aktiv" werden.',
      ACTIVE_TITLE: 'Status ändern zu "Aktiv" ?',
      ADMINISTRATOR: 'Kunde (Administrator)',
      ADMINISTRATOR_DESCRIPTION: 'Ein Administrator kann Benutzer und Manager erstellen und E-Mail-Adressen unter Benachrichtigungen hinzufügen.',
      CHANGE_TO_ACTIVE: 'ändern zu "Aktiv".',
      CHANGE_TO_INACTIVE: 'ändern zu "Inaktiv".',
      CREATE_USER: 'Benutzer erstellen',
      CREATE_USER_DESCRIPTION: 'Der Benutzer, den Sie jetzt erstellen, befindet sich in "inaktiv" bis Sie die E-Mail-Adresse bestätigen und ein Passwort erstellen.',
      DELETE: 'Benutzer entfernen',
      DELETE_DESCRIPTION: 'Möchten Sie diesen Benutzer wirklich entfernen? Bitte beachten Sie, dass von diesem Administrator erstellte Benutzer verloren gehen.',
      DESCRIPTION: 'Ein Benutzer kann nach der Bestätigung auf das Portal zugreifen. Wenn die E-Mail nicht bestätigt wird, bleibt ein Benutzer inaktiv.',
      EDIT_USER: 'Benutzer ändern',
      EDIT_USER_DESCRIPTION: 'Der Benutzer, den Sie jetzt ändern, befindet sich in "inaktiv" bis Sie die E-Mail-Adresse bestätigen und ein Passwort erstellen.',
      EMAIL_LANGUAGE: 'Wählen Sie die Sprache der zu empfangenden E-Mails aus',
      EMAIL_LANGUAGE_DISABLED_LABEL: 'E-Mail-Sprache',
      FIRST_NAME: 'Vorname',
      INACTIVE_DESCRIPTION: 'Möchten Sie den Status dieses Benutzers wirklich ändern zu "inaktiv"? Bitte beachten Sie, dass alle von diesem Administrator erstellte Benuzter "inaktiv" werden.',
      INACTIVE_TITLE: 'Status ändern zu "Inaktiv" ?',
      LAST_NAME: 'Nachname',
      MANAGER: 'Manager',
      MANAGER_DESCRIPTION: 'Zusätzlich zu den gleichen Rechten wie ein Benutzer hat ein Manager auch die Möglichkeit, Benutzer zu erstellen und E-Mails unter Meldungen hinzuzufügen',
      NO_USERS_FOUND: 'Entschuldigung, wir haben keine Benutzer gefunden',
      ROLE: 'Rolle',
      ROW_LABEL: {
        NAME: 'Name',
        LAST_LOGIN: 'Letzter login',
        LINKED_COMPANIES: 'Verbundene Firma'
      },
      SEARCH_TEXT: 'Suche ein Benutzer nach Vorname, Nachname oder E-Mail',
      SEARCH_TEXT_COMPANY: 'Suche ein Benutzer nach Vorname, Nachname, Firmennamen, E-Mail oder Kundennummer',
      SET_STATUS_ACTIVE: 'Setz den Status auf "aktiv"',
      SET_STATUS_INACTIVE: 'Setz den Status auf “inaktiv”.',
      STATUS_PORTAL: 'Status',
      SUPERADMIN: 'Super Admin',
      SUPERADMIN_DESCRIPTION: 'Dies ist ein Superadministrator',
      SUPPORT: 'Roba-Support',
      SUPPORT_DESCRIPTION: 'Der Roba-Support kann sich als Benutzer ausgeben und bei Fragen zum Portal helfen',
      USER: 'Benutzer',
      USER_DESCRIPTION: 'Ein Benutzer hat Zugriff auf das Portal und kann alle Dokumente einsehen'
    },
    NOTIFICATION: {
      ADDED_EMAIL_ADDRESSES: 'Hinzugefügte E-Mail-Adressen',
      ADD_EMAIL: 'E-mail hinzufügen',
      ADD_EMAIL_DESCRIPTION: 'Sie werden benachrichtigt, sobald ein neues Type Dokument in das Portal hochgeladen wird oder Sie bekommen eine E-Mail mit den beigefügten Dokumenten.',
      ADD_EMAIL_TO_NOTIFICATION: 'Eine E-Mail-Adresse hinzufügen zu Meldungen',
      DELETE_EMAIL: 'E-Mail löschen',
      DELETE_EMAIL_NOTE: 'E-Mail wird aus diesen Dokumenten entfernt',
      EDIT_EMAIL: 'E-Mail bearbeiten',
      EMAIL_DESCRIPTION: 'Die hinzugefügten E-Mail-Adressen erhalten {0} Dokumente per E-Mail, sobald sie von Roba Metals auf das Portal hochgeladen werden.',
      EMAIL_SEARCH: 'Geben Sie hier die gesuchte E-Mail-Adresse ein.',
      INVOICES: 'Rechnung',
      NOTIFICATION_TEXT: 'Sie werden benachrichtigt, sobald ein neues Type Dokument in das Portal hochgeladen wird oder Sie bekommen eine E-Mail mit den beigefügten Dokumenten.',
      NOTSET: 'Nicht eingestellt',
      NO_EMAILS_ADDED: 'Keine E-Mail-Adressen hinzugefügt.',
      OPTIONS: 'Benachrichtigungsoptionen',
      OPTIONS_TEXT:
        'Die ausgewählten Dokumente werden an die E-Mail-Adresse gesendet, sobald sie in das Portal hochgeladen werden. Am Ende jedes Tages erhalten Sie eine allgemeine Meldung damit der Benutzer weißt, dass dem Portal neue Dokumente hinzugefügt wurden.',
      OPTIONS_SELECT_DOCUMENTS: 'Wählen Sie Dokumente aus, die Sie per E-Mail senden möchten',
      PACKINGSLIPS: 'Packzettel & Zertifikate',
      SALESORDERS: 'Verkaufsauftrag',
      SALESAGREEMENTS: 'Verkaufsvertrag',
      LANGUAGE: {
        NL: 'Niederländisch',
        DE: 'Deutsche',
        FR: 'Französisch',
        EN: 'Englisch'
      }
    }
  },
  LOGIN: {
    LOGIN: 'Einloggen',
    FORGOT_PASSWORD: 'Passwort vergessen',
    GENERAL_PURCHASING_CONDITIONS: 'Allgemeine Einkaufsbedingungen',
    GENERAL_SALES_CONDITIONS: 'Allgemeine Verkaufsbedingungen',
    DISCLAIMER: 'Disclaimer'
  },
  SUPPORT: {
    BACK_TO_LOGIN: 'Zum Login',
    TITLE: 'Support',
    TEXT: 'Wenn Sie Probleme mit dem Portal haben oder Fragen zum Inhalt haben, kontaktieren Sie Ihren Accountmanager bitte per E-Mail oder Telefon'
  },
  CREATE_PASSWORD: {
    CREATE: 'Account erstellen',
    CREATE_PASSWORD: 'Passwort erstellen',
    REPEAT_PASSWORD: 'Passwort wiederholen',
    VALIDATION: {
      LENGTH: 'Mindestens 7 Zeichen',
      ONE_LOWERCASE: 'Mindestens einen Kleinbuchstaben',
      ONE_SPECIAL_CHARACTER: 'Mindestens ein Sonderzeichen',
      EQUAL_PASSWORDS: 'Passwörter sind identisch'
    }
  },
  REQUEST_PASSWORD: {
    REQUEST: 'Anfragen',
    REQUEST_PASSWORD: 'Neues Passwort anfragen',
    REQUEST_PASSWORD_SENT: 'Wir haben Ihnen eine E-Mail geschickt',
    TEXT: 'Wenn Sie Probleme mit dem Portal haben oder Fragen zum Inhalt haben, kontaktieren Sie Ihren Accountmanager bitte per E-Mail oder Telefon'
  },
  IMPERSONATE: {
    TITLE: 'Customers - Impersonate mode',
    COMPANY_PLACEHOLDER: 'Suche oder Wählen eine Firma',
    USER_PLACEHOLDER: 'Suche oder Wählen ein Benutzer'
  },
  SET_COMPANY: {
    TITLE: 'Unternehmen auswählen',
    COMPANY_PLACEHOLDER: 'Suche oder Wählen eine Firma'
  },
  VALIDATION_ERROR: {
    FIRSTNAME_REQUIRED: 'Vorname ist verpflichtet',
    LASTNAME_REQUIRED: 'Nachname ist verpflichtet',
    USERNAME_REQUIRED: 'Benutzername ist verpflichtet',
    PASSWORD_REQUIRED: 'Passwort ist verpflichtet',
    ROLECREATE_NOTALLOWED: 'Rolle nicht gültig',
    PASSWORD_DIFFERENT: 'Passworte sind nicht identisch',
    NEWPASSWORD_REQUIRED: 'Passwort ist verpflichtet',
    REPEATPASSWORD_REQUIRED: 'Passwort ist verpflichtet',
    NAME_REQUIRED: 'Name ist verpflichtet',
    EMAIL_REQUIRED: 'E-mail ist verpflichtet',
    MINIMUM_ONE_TYPE: 'Mindestens 1 Typ muss ausgewählt werden',
    PASSWORDTOOSHORT: 'Passwort ist zu kurz',
    PASSWORDREQUIRESNONALPHANUMERIC: 'Das Passwort muss aus mindestens ein Sonderzeichen enhalten.',
    PASSWORDREQUIRESLOWER: 'Das Passwordt muss aus mindestens ein Kleinbuchstaben.',
    USERNAMEALREADYTAKEN: 'Benutzername ist bereist verwendet',
    EMAILALREADYTAKEN: 'E-Mail-Adresse ist bereits verwendet',
    LOGIN_INCORRECT: 'Ungültige Kombination',
    CUSTOMERNR_REQUIRED: 'Kundennummer ist verpflichtet',
    COMPANYNAME_REQUIRED: 'Firmenname ist verpflichtet',
    CUSTOMERNRALREADYTAKEN: 'Kundennummer ist bereits verwendet',
    EMAIL_INVALID: 'E-Mail-Adresse Ungültig',
    INVALIDTOKEN: 'Token Ungültig',
    TOKEN_REQUIRED: 'Token ist verpflichtet',
    USER_MUST_HAVE_COMPANY: 'Ihr Konto ist nicht mehr verlinkt. Sollte dies nicht der Fall sein, wenden Sie sich bitte an den Roba Metals Account Manager.'
  },
  ENUM: {
    PORTAL_STATUS: {
      ACTIVE: 'Aktiv',
      INACTIVE: 'Inaktiv'
    },
    USER_ROLE: {
      USER: 'Benuzter',
      MANAGER: 'Manager',
      ADMINISTRATOR: 'Administrator',
      SUPERADMIN: 'Super Admin',
      SUPPORT: 'Support'
    },
    DOCUMENT_TYPE: {
      CERTIFICATES: 'Zertifikate',
      INVOICES: 'Rechnungen',
      NOTSET: 'Nicht eingestellt',
      PACKINGSLIPS: 'Packzettel',
      SALESAGREEMENTS: 'Verkaufsvertrag',
      SALESORDERS: 'Verkaufsauftrag'
    },
    DOCUMENT_SORT: {
      UPLOADDATEASC: 'Datum aufsteigend',
      UPLOADDATEDESC: 'Datum ablaufend',
      DOCUMENTTYPEASC: 'Type Dokument'
    },
    DOCUMENT_SEARCH_TYPE: {
      NONE: 'None',
      ARTICLENR: 'Ihre Artikelnummer',
      CLIENTREFERENCE: 'Ihre Referenz',
      SALESORDER: 'Verkaufsauftrag Nummer',
      SALESAGREEMENT: 'Verkaufsvertrag Nummer',
      PACKINGSLIP: 'Packzettel Nummer',
      BATCHNR: 'Batch Nummer',
      CERTIFICATENR: 'Zertifikat Nummer',
      INVOICENR: 'Rechnung Nummer'
    }
  },
  DASHBOARD: {
    DOCUMENTS_ADDED: 'Hinzugefügte Dokumente seit dem letzten Besuch',
    LAST_VISIT: 'letzter Besuch',
    TONNAGE_DELIVERED: 'Tonnen in diesem Jahr geliefert an',
    NEW_DOCUMENTS: 'Neue Dokumente',
    DOCUMENTS: 'Dokumente',
    SUPPORT_BLOCK: {
      ACTION: 'Bei weitere Rückfragen melden Sie sich gerne',
      TITLE: 'Zuverlässiger Partner in Metall'
    }
  },
  DOCUMENTS: {
    DOCUMENT_TYPE: 'Type Dokument',
    GROUP_FUTURE: 'Zukunft',
    GROUP_TODAY: 'Heute',
    GROUP_THIS_WEEK: 'Diese Woche',
    GROUP_THIS_MONTH: 'Dieser Monat',
    GROUP_LAST_MONTH: 'Letzter Monat',
    GROUP_THIS_YEAR: 'Dieses Jahr',
    GROUP_PREVIOUS_YEARS: 'Vergangenen Jahren',
    GROUP_SEARCH_RESULT: 'Suchergebnisse',
    GROUP_SEARCH_RELATED: 'Zugehörigen Dokumenten für {0} "{1}"',
    SEARCH_TEXT: 'Geben Sie {0} ein um übereinstimmende Dokumente zu finden',
    NO_DOCUMENTS_FOUND: 'Leider habeb wir keine Dokumente gefunden',
    NO_VERSIONS_FOUND: 'Leider habeb wir keine Versionen gefunden',
    BATCH_NUMBER: 'Batch Nummer',
    CERTIFICATE_NUMBER: 'Zertifikatnummer',
    EXTERNAL_CUSTOMER_REFERENCE: 'Kundenreferenz',
    CUSTOMER_NUMBER: 'Kundennummer',
    INVOICE_NUMBER: 'Rechnung Nummer',
    PACKING_SLIP_NUMBER: 'Packzettel Nummer',
    ROBA_NUMBER: 'Roba nummer',
    DOWNLOAD_DOCUMENTS: 'Download Dokumente',
    PREPARING_YOUR_DOWNLOAD: 'Ihre download vorbereiten',
    SELECTED_DOCUMENTS: 'Ausgewählten Dokumenten',
    PREVIEW: 'Vorschau',
    SELECT_DOCUMENT: 'Wählen Sie ein Dokument aus',
    RELATED_DOCUMENTS: 'Zugehörige Dokumente',
    VERSION_HISTORY: 'Historie',
    DOWNLOAD: 'Download',
    UPLOAD_DATE: 'Upload Datum',
    VERSION_NUMBER: 'Version Nummer',
    MULTIPLE_BATCHES: 'Mehrere Batches',
    CERTIFICATE_MULTIPLE_BATCHES: 'Zertifikate für mehrere Batches'
  },
  COMPANIES: {
    CREATE_COMPANY: 'Unternehmen erstellen',
    META_TITLE: 'Firmen',
    SEARCH_PLACEHOLDER: 'Suche nach einem Unternehmen nach Namen oder Kundennummer.',
    ROW_LABELS: {
      COMPANY_NAME: 'Firmenname',
      CUSTOMER_NR: 'Kunden-Nr.',
      DATE_CREATED: 'Erstellungsdatum',
      LAST_LOGIN: 'Letzter Login',
      STATUS: 'Status'
    }
  },
  COMPANY: {
    ADD_COMPANY: {
      ACCESS_TO: 'Zugang zu welchen Unternehmen?',
      BUTTON: 'Weiteres Unternehmen hinzufügen',
      NO_DATA: 'Keine Firmen gefunden',
      PLACEHOLDER: 'Suche ein Unternehmen nach Name oder  Kundennummer',
      TITLE: 'Unternehmen hinzufügen'
    },
    COMBINE: 'Die Dokumentinformationen der ausgewählten Unternehmen zusammenführen? ',
    CORPORATE: 'Firmenname',
    CORPORATE_DESCRIPTION: 'Dieser Name wird im Portal verwendet.',
    DELETE_COMPANY: 'Unternehmen löschen',
    EDIT_COMPANY: 'Unternehmen bearbeiten',
    DELETE_DESCRIPTION: 'Bei allen verknüpften Admins verschwindet dann dieses Unternehmen.',
    SET_STATUS_ACTIVE: 'Ändern zu "Aktiv".',
    SET_STATUS_INACTIVE: 'Ändern zu "Inaktiv".',
    STATUS_ACTIVE_TITLE: 'Ändern zu "Aktiv"?',
    STATUS_INACTIVE_TITLE: 'Ändern zu "Inaktiv"?'
  }
}

export default translations
